
import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { format } from 'date-fns';

export interface DateRange {
  from: Date;
  to: Date;
}

export type DateRangeType = DateRange | '7days' | '30days' | '90days' | 'today';

interface DateRangeFilterProps {
  dateRange?: DateRange;
  onDateRangeChange?: (range: DateRange) => void;
  value?: DateRangeType;
  onChange?: (value: DateRangeType) => void;
}

export function DateRangeFilter({ 
  dateRange, 
  onDateRangeChange, 
  value, 
  onChange 
}: DateRangeFilterProps) {
  // If using the object-based API
  if (dateRange && onDateRangeChange) {
    return (
      <div className="grid gap-2">
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="justify-start text-left font-normal"
            >
              <span>
                {dateRange.from ? (
                  <>
                    {format(dateRange.from, "LLL dd, y")} -{" "}
                    {dateRange.to ? format(dateRange.to, "LLL dd, y") : "..."}
                  </>
                ) : (
                  "Select date range"
                )}
              </span>
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="range"
              selected={{
                from: dateRange.from,
                to: dateRange.to
              }}
              onSelect={(range) => {
                if (range?.from && range?.to) {
                  onDateRangeChange({
                    from: range.from,
                    to: range.to
                  });
                }
              }}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>
    );
  }
  
  // If using the string-based API
  return (
    <div className="flex space-x-1">
      <Button 
        variant={value === 'today' ? "default" : "outline"}
        onClick={() => onChange && onChange('today')}
        className="text-xs md:text-sm px-2 md:px-3"
      >
        Today
      </Button>
      <Button 
        variant={value === '7days' ? "default" : "outline"}
        onClick={() => onChange && onChange('7days')}
        className="text-xs md:text-sm px-2 md:px-3"
      >
        7 Days
      </Button>
      <Button 
        variant={value === '30days' ? "default" : "outline"}
        onClick={() => onChange && onChange('30days')}
        className="text-xs md:text-sm px-2 md:px-3"
      >
        30 Days
      </Button>
      <Button 
        variant={value === '90days' ? "default" : "outline"}
        onClick={() => onChange && onChange('90days')}
        className="text-xs md:text-sm px-2 md:px-3"
      >
        90 Days
      </Button>
    </div>
  );
}
